<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2.72168 13.7418L7.46468 17.3618L15.0807 8.6578L13.5747 7.3418L7.19068 14.6378L3.93368 12.1518L2.72168 13.7418ZM22.0807 8.6578L20.5747 7.3418L14.2057 14.6208L13.4527 14.0188L12.2027 15.5808L14.4497 17.3788L22.0807 8.6578Z"
    fill="#12B75F"
  />
</svg>
